import { AuthenticationService } from './../../../services/authentication.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-recuperarPass',
  templateUrl: './recuperarPass.component.html',
  styleUrls: ['./recuperarPass.component.scss'],
  providers: [AuthenticationService]
})
export class RecuperarPassModalComponent implements OnInit {

  username = '';
  mensaje = '';
  idioma;
  mostrarMensaje: boolean = false;
  cerrarMensaje: boolean = false;
  respuestaS: boolean = false;
  closeResult: string;
  busy: boolean = false;
  timeToMail:string;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {
    this.noBack();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  recuperarPass() {
    this.busy = true;
    this.authenticationService.recuperarPassword(this.username, this.idioma).subscribe(
      data => {
        this.busy = false;

        if (data != null) {
          if (data.message == "El usuario no existe, favor de validar e intentar nuevamente" ||
            data.message == "The user does not exist, please validate and try again") {
            this.cerrarMensaje = false;
          } else {
            this.cerrarMensaje = true;
           // this.activeModal.close();
          }

          this.mostrarMensaje = true;
          this.mensaje = data.message;
        }
      },
      error => {
        this.busy = false;
        this.mostrarMensaje = true;
        this.mensaje = error.message;

      }
    )

  }

  closeModal() {
    this.activeModal.close();
  }

  cambiarMensaje() {
    this.mostrarMensaje = !this.mostrarMensaje;
    this.username = '';
  }

}






// WEBPACK FOOTER //
// ./src/app/pages/login/recuperarPassword/recuperarPass.component.ts